/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_screen_framerate = /** @type {(inputs: {}) => string} */ () => {
	return `Framerate`
};

const da_attributes_screen_framerate = /** @type {(inputs: {}) => string} */ () => {
	return `Framerate`
};

const de_attributes_screen_framerate = /** @type {(inputs: {}) => string} */ () => {
	return `Framerate`
};

const en_attributes_screen_framerate = /** @type {(inputs: {}) => string} */ () => {
	return `Framerate`
};

const es_attributes_screen_framerate = /** @type {(inputs: {}) => string} */ () => {
	return `Framerate `
};

const fr_attributes_screen_framerate = /** @type {(inputs: {}) => string} */ () => {
	return `Framerate`
};

const hu_attributes_screen_framerate = /** @type {(inputs: {}) => string} */ () => {
	return `Framerate`
};

const it_attributes_screen_framerate = /** @type {(inputs: {}) => string} */ () => {
	return `Framerate`
};

const nl_attributes_screen_framerate = /** @type {(inputs: {}) => string} */ () => {
	return `Framerate`
};

const pl_attributes_screen_framerate = /** @type {(inputs: {}) => string} */ () => {
	return `Framerate`
};

const pt_attributes_screen_framerate = /** @type {(inputs: {}) => string} */ () => {
	return `Framerate `
};

const sv_attributes_screen_framerate = /** @type {(inputs: {}) => string} */ () => {
	return `Framerate`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_screen_framerate = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_screen_framerate(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_screen_framerate", locale)
	if (locale === "cs") return cs_attributes_screen_framerate(inputs)
	if (locale === "da") return da_attributes_screen_framerate(inputs)
	if (locale === "de") return de_attributes_screen_framerate(inputs)
	if (locale === "en") return en_attributes_screen_framerate(inputs)
	if (locale === "es") return es_attributes_screen_framerate(inputs)
	if (locale === "fr") return fr_attributes_screen_framerate(inputs)
	if (locale === "hu") return hu_attributes_screen_framerate(inputs)
	if (locale === "it") return it_attributes_screen_framerate(inputs)
	if (locale === "nl") return nl_attributes_screen_framerate(inputs)
	if (locale === "pl") return pl_attributes_screen_framerate(inputs)
	if (locale === "pt") return pt_attributes_screen_framerate(inputs)
	return sv_attributes_screen_framerate(inputs)
};
export { attributes_screen_framerate as "attributes.screen_framerate" }